import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {getOrphanProducts} from "../../server/Product";


const Products = () => {

    const dispatch = useDispatch();
     const { products } = useSelector((state) => ({
        products: state.displayProduct.itemsShow,
      }));
    
    useEffect(() => { 
        dispatch(getOrphanProducts());
    }, [products]);


    return (
        <ul>
            {products.map((prod) => (
                <li><a href={`/edit-product/${prod.Mkt}/information`}>{prod.ProductName}</a></li>
            ))}
        </ul>
    
    );
}

export default Products;